/**
 * @description 发布统计 releaseStatistics
 * @author xiehan
 * @date 2018/12/17
 */

import Logic from '../logic-base'

const releaseStatisticsBiz = new Logic()

releaseStatisticsBiz.getAllcount = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.releaseStatistics.getAllcount,
    data: data
  })
}

releaseStatisticsBiz.get = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.releaseStatistics.get,
    data: data
  })
}

export default releaseStatisticsBiz
